<template>
  <div :class="$style.content">
    <h3>{{ data.title }}<br />{{ data.sub_title }}</h3>
    <p>{{ data.content }}</p>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="less" module>
.content {
  @title-height: 1.22rem;
  @title-padding-top: 0.2rem;
  @title-font-size: 0.26rem;

  overflow: hidden;

  h3 {
    position: relative;
    height: @title-height;
    padding-top: @title-padding-top;
    font-weight: 700;
    font-size: @title-font-size;
    line-height: 1.4;
    white-space: nowrap;
  }

  p {
    padding-top: 0.3rem;
    border-top: 1px solid #bfbfbf;
    line-height: 2.2;
  }

  @media screen and (max-width: @tablet-width) {
    h3 {
      font-size: @title-font-size * 1.2;
    }

    p {
      font-size: 12px;
      line-height: 2;
    }
  }

  @media screen and (max-width: @mini-width) {
    h3 {
      height: auto;
      padding-top: @title-padding-top * @life-charity-mini;
      padding-bottom: @title-padding-top * @life-charity-mini;
      font-size: 16px;
    }
  }

  @media screen and (max-width: @mobile-width) {
    h3 {
      font-size: 14px;
    }
  }
}
</style>
